import { useLoaderData } from "@remix-run/react";
import { MetaFunction } from "@remix-run/node";
import BlogsCategory from "~/components/blocks/BlogsCategory";
import { BlogChipFilterLoader } from "~/lib/helpers/blogChipFilterLoader";
import { buildBlogListingMeta } from "~/utils/Meta/blogListingMeta";

const CHIP_VALUE = "Case Study";
const BLOG_CATEGORY = "blog";
const BLOG_SUB_CATEGORY = "case study / success story";

export const meta: MetaFunction = ({ data, location }) => {

    return buildBlogListingMeta({
        data,
        location,
        title: `Workspace Case Studies & Client Success Stories`,
        description: `See how businesses found and scaled into the right office spaces through real client stories, relocation journeys and workspace solutions.`,
    });
};

export const loader = BlogChipFilterLoader(BLOG_CATEGORY, BLOG_SUB_CATEGORY, CHIP_VALUE);

export default function BlogCaseStudy() {
    const { blog, country, isMobile, region, featuredBlogs } = useLoaderData<typeof loader>();

    return (
        <BlogsCategory
            blog={blog}
            featuredBlogs={featuredBlogs}
            params={{ country: region }}
            title={`Case Study / Success Story`}
            region={region}
            country={country}
            category=""
            blogCategory={BLOG_CATEGORY}
            blogSubCategory={BLOG_SUB_CATEGORY}
            isMobile={isMobile}
            showFilterChips
            selectedChip={CHIP_VALUE}
            marketingHero
        />
    );
}
